module.exports = {
	"awsCognito": {
		"region": "us-east-1",
		"userPoolId": "us-east-1_xTJChPP6y",
		"appClientId": "1hhf2dhv7d85jvivncmljuorgd"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 293
// module chunks = 0